import { makeObservable, observable } from 'mobx';
import { z } from 'zod';
import type { RequireAllProps } from '../../../../../store/utils/Dto';
import type { AccountSaveMethod } from '../../types';
import Service, { type ServiceDto } from '../Service';

export default class Wix extends Service<WixDto> {
  static Schema = z.object({
    webhookSecret: z.string().min(1),
  });

  webhookSecret = '';

  constructor(dto: WixDto = {} as any, onSave?: AccountSaveMethod) {
    super(dto, onSave);

    makeObservable(this, {
      webhookSecret: observable,
    });

    Object.assign(this, dto);
  }

  toJSON(): RequireAllProps<WixDto> {
    return {
      ...super.toJSON(),
      webhookSecret: this.webhookSecret,
    };
  }
}

export interface WixDto extends ServiceDto {
  webhookSecret?: string;
}
